import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIsDataDirty } from '../../features/app/selectors';

const PromptOnUnload = () => {
  const isDataDirty = useSelector(getIsDataDirty);

  const register = useCallback(() => {
    // Detecting browser close
    window.onbeforeunload =
      isDataDirty &&
      (() => 'You will loose the changes you have made on this page.');
  }, [isDataDirty]);

  const unregister = useCallback(() => {
    window.onbeforeunload = null;
  }, []);

  useEffect(() => {
    register();
    return unregister;
  }, [register, unregister]);

  return null;
};

export default PromptOnUnload;
